

// object to store loaded CSS chunks
var installedCssChunks = {
	47: 0
}
__webpack_require__.f.compat = (chunkId, promises) => {


	// mini-css-extract-plugin CSS loading
	var cssChunks = {"613":1,"690":1,"901":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
			var href = "static/css/" + ({"25":"manager-accounts-details","37":"manager-offerings","58":"manager-portal-settings","71":"edit-accountsWizard","89":"manager-test","91":"contacts-profile","112":"user-settings","154":"manager-offerings-change-rate","231":"dashboard-manager-trackRecord-review-records","260":"investor-managerPage","307":"manager-reports","342":"marketing-home","368":"investor-create-investment","372":"manager-dashboard-accounts-create","378":"manager-offerings-allocation-methods","403":"dashboard-manager-trackRecord-add-investment","438":"dashboard-manager-contactImport","499":"getStarted","509":"dashboard-manager-trackRecord-start","514":"docusignPage","546":"loginPage","586":"marketing-pricing","603":"manager-offerings-transfer","610":"manager-new-reports","613":"dashboard-manager-brownfieldImport","628":"dashboardPage","667":"investor-accountsDocumentsPage","690":"fund-builder-wizard","729":"dashboard-manager-onboardingWizard-switch-manager","759":"empty-page-to-create-fund-builder","763":"manager-new-contact","782":"investor-accountsSinglePage","811":"manager-offerings-details","817":"manager-imports","832":"manager-dashboard-accounts","870":"manager-investments","878":"investor-portal-auth","884":"manager-offerings-distributions","896":"manager-offerings-exchange-securities","901":"manager-profile","963":"manager-investment-details"}[chunkId]||chunkId) + "." + {"25":"31d6cfe0","37":"31d6cfe0","58":"31d6cfe0","71":"31d6cfe0","89":"31d6cfe0","91":"31d6cfe0","112":"31d6cfe0","154":"31d6cfe0","231":"31d6cfe0","260":"31d6cfe0","307":"31d6cfe0","342":"31d6cfe0","368":"31d6cfe0","372":"31d6cfe0","378":"31d6cfe0","403":"31d6cfe0","438":"31d6cfe0","499":"31d6cfe0","509":"31d6cfe0","514":"31d6cfe0","546":"31d6cfe0","586":"31d6cfe0","603":"31d6cfe0","610":"31d6cfe0","613":"ea7d08c6","628":"31d6cfe0","667":"31d6cfe0","690":"f3da8273","729":"31d6cfe0","759":"31d6cfe0","763":"31d6cfe0","782":"31d6cfe0","811":"31d6cfe0","817":"31d6cfe0","832":"31d6cfe0","870":"31d6cfe0","878":"31d6cfe0","884":"31d6cfe0","896":"31d6cfe0","901":"f3da8273","963":"31d6cfe0"}[chunkId] + ".chunk.css";
			var fullhref = __webpack_require__.p + href;
			var existingLinkTags = document.getElementsByTagName("link");
			for(var i = 0; i < existingLinkTags.length; i++) {
				var tag = existingLinkTags[i];
				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
			}
			var existingStyleTags = document.getElementsByTagName("style");
			for(var i = 0; i < existingStyleTags.length; i++) {
				var tag = existingStyleTags[i];
				var dataHref = tag.getAttribute("data-href");
				if(dataHref === href || dataHref === fullhref) return resolve();
			}
			var linkTag = document.createElement("link");
			linkTag.rel = "stylesheet";
			linkTag.type = "text/css";
			linkTag.onload = resolve;
			linkTag.onerror = function(event) {
				var request = event && event.target && event.target.src || fullhref;
				var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
				err.code = "CSS_CHUNK_LOAD_FAILED";
				err.request = request;
				delete installedCssChunks[chunkId]
				linkTag.parentNode.removeChild(linkTag)
				reject(err);
			};
			linkTag.href = fullhref;

			var head = document.getElementsByTagName("head")[0];
			head.appendChild(linkTag);
		}).then(function() {
			installedCssChunks[chunkId] = 0;
		}));
	}
};